import React from "react";
import { MessageCircleIcon } from "lucide-react";
import { company } from "../i18n/translations";
export function WhatsAppButton() {
  return <a href={company.whatsappLink} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105" data-id="element-291" data-mp="1se1x2fgbrae0">
      <MessageCircleIcon size={28} data-id="element-292" data-mp="1eesp2329vml4" />
    </a>;
}